export default {
  MuiCheckbox: {
    styleOverrides: {
      root: {
        padding: '0px',
        '&.MuiCheckbox-root > svg': { fontSize: '1.125rem' },
        '&.Mui-checked': {
          color: '#0F62FE' // 勾選時為藍色
        }
      }
    }
  }
};
